<template>
  <v-flex xs12 sm6 offset-sm3>
    <v-card>
      <v-card-text>
        <v-list-item>
          <v-list-item-avatar color="white">
            <img alt="logo" src="@/assets/logo.png">
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="headline">Réinitialisation du mot de passe</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-form
          ref="form"
          @keyup.native.enter="reset"
        >
          <v-text-field
            v-model="email"
            label="E-mail"
            :rules="[rules.required]"
          ></v-text-field>

          <v-btn
            block
            depressed
            color="primary"
            @click="reset"
            :disabled="loading" 
            :loading="loading"
          >Envoyer</v-btn>

        </v-form>

        <v-btn
          block
          text
          small
          color="secondary"
          :to="{ name: 'login' }"
          class="mt-4"
        >Se connecter</v-btn>

      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
    export default {
        data(){
            return {
                email: '',
                rules: {
                    required: value => !!value || 'Champ requis',
                },
                loading: false,
            }
        },
        methods: {
            reset: function () {
              if (this.$refs.form.validate()) {
                this.loading = true
                const { email } = this;
                this.$store.dispatch('resetPassword', { email })
                    .then(() => {
                        this.loading = false
                        this.$router.push('/login')
                    })
                    .catch((err) => {
                        this.loading = false;
                    })
              }
            }
        }
    }
</script>
